import { createContext } from 'react';

const OnboardingContext = createContext(null);

export default OnboardingContext;
